import type { ReactNode } from 'react';
import type { AccordionProps, AccordionSummaryProps } from '@mui/material';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  styled,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Should be moved to Components
export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.grey['200']}`,
  overflow: 'hidden',
  borderRadius: '8px',
  '&:before': {
    display: 'none',
  },
}));

// Should be moved to Components
export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.grey[100],
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

type Props = {
  title?: string;
  defaultExpanded?: boolean;
  children: NonNullable<ReactNode>;
};

const PropertyPanelAccordion = ({
  title,
  defaultExpanded,
  children,
}: Props) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1a-content'
        id='panel1a-header'
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default PropertyPanelAccordion;
